export const isBrowser = () => globalThis.window !== undefined
